var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#B8170D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1285_4765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1285_4765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.45 27.3002L21.15 24.0002H8.00002C7.45002 24.0002 6.97919 23.8044 6.58752 23.4127C6.19586 23.021 6.00002 22.5502 6.00002 22.0002V10.0002C6.00002 9.4502 6.19586 8.97936 6.58752 8.5877C6.97919 8.19603 7.45002 8.0002 8.00002 8.0002V10.8502L4.65002 7.5002L6.07502 6.0752L25.875 25.8752L24.45 27.3002ZM8.00002 22.0002H19.15L9.15002 12.0002H8.00002V22.0002ZM25.775 22.9252L24 21.1502V12.0002H14.85L10.85 8.0002H24C24.55 8.0002 25.0209 8.19603 25.4125 8.5877C25.8042 8.97936 26 9.4502 26 10.0002V22.0002C26 22.1669 25.9834 22.3294 25.95 22.4877C25.9167 22.646 25.8584 22.7919 25.775 22.9252Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveBox);
export default __webpack_public_path__ + "static/media/inactiveBox.28a1a844a31a5754d8fb13e4f7b19989.svg";
export { ForwardRef as ReactComponent };